import _ from "lodash";

export const getIsDataPresent = (data) => {
  const recordsWithValues = _.filter(data, function (o) { return !!o.value; });
  return !!recordsWithValues.length
}